
import { useEffect, useContext } from 'react';
import useAppState from 'hooks/useAppState';
import SessionContext from "SessionContext";

/**
 * @param {*} hasLicense function to use as listener for the response.
 * @returns true if a license is found, false if not.
 */
function HasLicenseFee({hasLicense}) {
    const appState = useAppState();
    const session = useContext(SessionContext);
    
    useEffect(() => {
        if(appState.loaded) {
          loadLicenseFee(appState.activeCompany.id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appState.loaded])

    const loadLicenseFee = (company_id) => {
        session.query("admin/get_current_licence_fee", { am_company_id: company_id })
        .then((response) => {
            if("id" in response) {
              hasLicense(true);
            } else if(appState.activeCompany && appState.activeCompany.override_license_requirement) {
              hasLicense(true);
            } else {
              hasLicense(false);
            }
        })
        .catch((error) => {
            hasLicense(false);
            console.log(JSON.stringify(error));
        });
    }

  return "";
}

export default HasLicenseFee;


